import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lockedout',
  standalone: true,
  imports: [],
  templateUrl: './lockedout.component.html',
  styleUrl: './lockedout.component.css'
})
export class LockedoutComponent {
  constructor(
    private router: Router) {
  }
  home() {
    this.router.navigate(['']);
  }
  resetpassword() {
    this.router.navigate(['resetpassword']);
  }
}
